import { Box, Typography } from "@mui/material"

export function PdfPageError({ message }) {
    return (
        <Box className="pdf-ready pdf-error" sx={{ p: 4, bgcolor: "white", color: "#111827" }}>
            <Typography sx={{ fontWeight: 700, fontSize: "14px", mb: 1 }}>Authoring PDF export failed</Typography>
            <Typography sx={{ fontSize: "10px" }}>{message}</Typography>
        </Box>
    )
}
